export const ACTIONS = {
  destroy: 'destroyed',
  create: 'created',
  update: 'updated',
};
